import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-BurgerShape",
  "use": "svg-icon-BurgerShape-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol viewBox=\"0 0 16 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-BurgerShape\"><g fill-rule=\"evenodd\"><rect width=\"16\" height=\"2\" rx=\"1\" /><rect y=\"6\" width=\"16\" height=\"2\" rx=\"1\" /><rect y=\"12\" width=\"16\" height=\"2\" rx=\"1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol